import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { Input, Select, Form, Col, notification, Row, Button } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 13,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 15,
    span: 5,
  },
};
const { Option } = Select;
const { TextArea } = Input;

const FirmUpdate = (props) => {
  const isDesktopOrLaptop = useMediaQuery({ query: "(min-device-width: 1224px)" });
  const isTabletOrMobileDevice = useMediaQuery({ query: "(max-device-width: 1224px)" });

  const onChangeFirmType = (value) => {
    setFirmTypeValue(value);
    setFirmClassId("");
    RequestHandler.get(`/FirmClass?firmTypeId=${value}`).then((res) => {
      setfirmClassDropdown(res.value);
    });
  };

  const [inputList, setInputList] = useState([]);
  const [wordList, setWordList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [Name, setName] = useState(props.Name);
  const [DirectiveName, setDirectiveName] = useState(props.DirectiveName);
  const [Email, setEmail] = useState(props.Email);
  const [ErpSalesCode, setErpSalesCode] = useState(props.ErpSalesCode);
  const [City, setCity] = useState(props.City);
  const [Town, setTown] = useState(props.Town);
  const [SpecialCode, setSpecialCode] = useState(props.SpecialCode);
  const [AuthorizationCode, setAuthorizationCode] = useState(props.AuthorizationCode);
  const [AccountCode, setAccountCode] = useState(props.AccountCode);
  const [groupCode, setGroupCode] = useState(props.GroupCode);
  const [TaxOffice, setTaxOffice] = useState(props.TaxOffice);
  const [Vkn, setVkn] = useState(props.Vkn);
  const [TcNo, setTcNo] = useState(props.TcNo);
  const [Phone, setPhone] = useState(props.Phone);
  const [MobilePhone, setMobilePhone] = useState(props.MobilePhone);
  const [Fax, setFax] = useState(props.Fax);
  const [Address, setAddress] = useState(props.Address);
  const [FirmTypeValue, setFirmTypeValue] = useState(props.FirmTypeValue);
  const [IsHasSendFirmToLogo, setIsHasSendFirmToLogo] = useState(props.IsHasSendFirmToLogo);
  const [FirmBranchNumber, setFirmBranchNumber] = useState(
    props.FirmBranchNumber
  );
  const [FirmClassId, setFirmClassId] = useState(props.FirmClassId);
  const [firmTypeDropdown, setfirmTypeDropdown] = useState(
    props.firmTypeDropdown
  );
  const [firmClassDropdown, setfirmClassDropdown] = useState(
    props.firmClassDropdown
  );
  const [ErpCode, setErpCode] = useState(props.ErpCode);
  const [AccountingCode, setAccountingCode] = useState(props.AccountingCode);
  const wordArray = [];

  useEffect(() => {
    props.wordList.map((item) => {
      let model = {
        word: item.word,
      };
      wordArray.push(model);
    });

    RequestHandler.get(`/Firm/GetFirmType`).then((response) => {
      setfirmTypeDropdown(response.data);
    });

    RequestHandler.get(`/FirmClass`).then((response) => {
      setfirmClassDropdown(response.value);
    });
    wordArray.length < 1 ? setWordList([{ word: "" }]) : setWordList(wordArray);
    setName(props.Name);
    setDirectiveName(props.DirectiveName);
    setEmail(props.Email);
    setGroupCode(props.GroupCode);
    setErpSalesCode(props.ErpSalesCode);
    setCity(props.City);
    setTown(props.Town);
    setSpecialCode(props.SpecialCode);
    setAuthorizationCode(props.AuthorizationCode);
    setAccountCode(props.AccountCode);
    setTaxOffice(props.TaxOffice);
    setVkn(props.Vkn);
    setTcNo(props.TcNo);
    setPhone("+90" + props.Phone);
    setMobilePhone("+90" + props.MobilePhone);
    setFax(props.Fax);
    setAddress(props.Address);
    setFirmTypeValue(props.FirmTypeValue);
    setFirmBranchNumber(props.FirmBranchNumber);
    setFirmClassId(props.FirmClassId);
    setErpCode(props.ErpCode);
    setAccountingCode(props.AccountingCode);
  }, [
    setName,
    setDirectiveName,
    setEmail,
    setErpSalesCode,
    setCity,
    setTown,
    setSpecialCode,
    setAuthorizationCode,
    setAccountCode,
    setTaxOffice,
    setVkn,
    setTcNo,
    setTcNo,
    setFax,
    setAddress,
    setFirmTypeValue,
    setFirmBranchNumber,
    setFirmClassId,
    setWordList,
    setGroupCode,
    setErpCode,
    setAccountingCode,
    props.Name,
    props.DirectiveName,
    props.Email,
    props.ErpSalesCode,
    props.City,
    props.Town,
    props.SpecialCode,
    props.AuthorizationCode,
    props.AccountCode,
    props.TaxOffice,
    props.Vkn,
    props.TcNo,
    props.Phone,
    props.MobilePhone,
    props.Fax,
    props.Address,
    props.FirmTypeValue,
    props.GroupCode,
    props.FirmBranchNumber,
    props.FirmClassId,
    props.wordList,
    props.ErpCode,
    props.AccountingCode
  ]);

  const openNotificationWithIconUpdate = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Güncelleme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...wordList];
    list[index][name] = value;
    setWordList(list);
  };

  const handleRemoveClick = (index) => {
    const list = [...wordList];
    list.splice(index, 1);
    setWordList(list);
  };

  const handleAddClick = () => {
    setWordList([...wordList, { word: "" }]);
  };

  const onFinishUpdate = (values) => {
    const words = [];
    wordList.map((item) => {
      words.push(item.word.trim());
    });
    var error = 0;
    words.map((item) => {
      var wordLength = item.length;
      if (wordLength < 5 && wordLength !== 0) {
        error += 1;
      }
    });

    RequestHandler.put(`/Firm`, {
      id: props.firmId,
      name: values.Name,
      firmTypeValue: values.FirmTypeValue === null ? 0 : parseInt(values.FirmTypeValue),
      firmBranchNumber: values.FirmBranchNumber,
      directiveName: values.DirectiveName,
      email: values.Email,
      erpSalesCode: values.ErpSalesCode,
      taxOffice: values.TaxOffice,
      vkn: values.Vkn,
      tcNo: values.TcNo,
      groupCode: values.GroupCode,
      phone: values.Phone,
      mobilePhone: values.MobilePhone,
      fax: values.Fax,
      address: values.Address,
      firmClassId: values.FirmClassId,
      erpCode: values.ErpCode,
      city: values.City,
      town: values.Town,
      specialCode: values.SpecialCode,
      authorizationCode: values.AuthorizationCode,
      accountCode: values.AccountCode,
      accountingCode: values.AccountingCode
    }, false, { rawResponse: true })
    .then((res) => {
      if (res.status == 200) {
        if (error == 0) {
          RequestHandler.put(`/Firm/FirmMatchingWordPut`, {
            firmId: props.firmId,
            words: words.filter((item) => item.name !== ""),
          }, false, { rawResponse: true }).then((response) => {
            if (response.status === 200) { }
          });
        } else {
          wordLengtError("error");
          setLoading(false);
        }
        setInputList(words);

        openNotificationWithIconUpdate("success");
        setTimeout(
          function () {
            props.sendDataForUpdate("success");
            setLoading(false);
          }.bind(this),
          2000
        );
      }else{
        setLoading(false)
        }
    }).catch(function (error) {
      setLoading(false);
    });
  };

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const onFinishFailedUpdate = () => setLoading(false);

  const wordLengtError = (type) => {
    notification[type]({
      message: "HATA",
      description:
        "Kelimeler bölümündeki harf sayısı 5ten küçük olduğu için güncelleme başarısız oldu, düzenleyip tekrar deneyin.",
      duration: 4,
    });
  };

  const onChangePhoneValue = (e) => {
    setPhone(e);
  };

  const onChangeEmailValue = (e) => {
    setEmail(e.target.value);
  };

  const onChangeCity = (e) => {
    setCity(e.target.value);
  };

  const onChangeTown = (e) => {
    setTown(e.target.value);
  };

  const onChangeSpecialCode = (e) => {
    setSpecialCode(e.target.value);
  };

  const onChangeAuthorizationCode = (e) => {
    setAuthorizationCode(e.target.value);
  };

  const onChangeAccountCode = (e) => {
    setAccountCode(e.target.value);
  };

  const onChangeErpSalesCode = (e) => {
    setErpSalesCode(e.target.value);
  };

  const onChangeVknValue = (e) => {
    setVkn(e.target.value);
  };

  const onChangeTcNoValue = (e) => {
    setTcNo(e.target.value);
  };

  const onChangeTaxValue = (e) => {
    setTaxOffice(e.target.value);
  };

  const onChangeMobilePhoneValue = (e) => {
    setMobilePhone(e);
  };

  const onChangeFirmGroupCode = (e) => {
    setGroupCode(e.target.value);
  };

  const onChangeFaxValue = (e) => {
    setFax(e.target.value);
  };

  const onChangeAddressValue = (e) => {
    setAddress(e.target.value);
  };

  const onChangeNameValue = (e) => {
    setName(e.target.value);
  };

  const onChangeFirmBranchNumberValue = (e) => {
    setFirmBranchNumber(e.target.value);
  };

  const onChangeDirectiveNameValue = (e) => {
    setDirectiveName(e.target.value);
  };

  const onChangeFirmClassValue = (e) => {
    setFirmClassId(e);
  };

  const onChangeErpCodeValue = (e) => {
    setErpCode(e.target.value);
  };

  const onChangeAccountingCode = (e) => {
    setAccountingCode(e.target.value);
  };

  const onClickFirmClassValue = (e) => {
    RequestHandler.get(`/FirmClass?firmTypeId=${FirmTypeValue}`).then((response) => {
      setfirmClassDropdown(response.value);
    });
  };

  const ScreenNameWithActiveTab = () => {
    switch (props.activeTab) {
      case "1":
        return "Cari";
      case "2":
        return "Banka";
      case "3":
        return "Masraf";
      case "4":
        return "Çek";
      case "5":
        return "Senet";
    }
  }

  return (
    <div>
      <Form
        {...layout}
        name="basic"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinishUpdate}
        onFinishFailed={onFinishFailedUpdate}
        fields={[
          { name: "Name", value: Name },
          { name: "DirectiveName", value: DirectiveName },
          { name: "Email", value: Email },
          { name: "ErpSalesCode", value: ErpSalesCode },
          { name: "TaxOffice", value: TaxOffice },
          { name: "Vkn", value: Vkn },
          { name: "GroupCode", value: groupCode },
          { name: "TcNo", value: TcNo },
          { name: "Phone", value: Phone },
          { name: "MobilePhone", value: MobilePhone },
          { name: "Fax", value: Fax },
          { name: "Address", value: Address },
          {
            name: "FirmTypeValue",
            value: FirmTypeValue === "0" ? null : FirmTypeValue,
          },
          { name: "FirmBranchNumber", value: FirmBranchNumber },
          { name: "FirmClassId", value: FirmClassId },
          { name: "ErpCode", value: ErpCode },
          { name: "City", value: City },
          { name: "Town", value: Town },
          { name: "SpecialCode", value: SpecialCode },
          { name: "AuthorizationCode", value: AuthorizationCode },
          { name: "AccountCode", value: AccountCode },
          { name: "AccountingCode", value: AccountingCode}
        ]}
      >
        <Row>
          {isDesktopOrLaptop && (
            <>
              <Col span={24}>
                <Form.Item
                  label={`${ScreenNameWithActiveTab("1")} Adı${props.activeTab=="1"?"/Ünvanı":""}`}
                  name="Name"
                  style={{ marginTop: "4%" }}
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Cari Adı/Ünvanı alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input onChange={onChangeNameValue} />
                </Form.Item>
                <Form.Item label="Talimat Ünvanı" name="DirectiveName">
                  <Input onChange={onChangeDirectiveNameValue} />
                </Form.Item>
                <Form.Item label="E-Posta Adresi" name="Email">
                  <Input onChange={onChangeEmailValue} />
                </Form.Item>
                <Form.Item label="Vergi Dairesi" name="TaxOffice">
                  <Input onChange={onChangeTaxValue} />
                </Form.Item>

                <Form.Item
                  label="Vergi Numarası"
                  name="Vkn"
                  rules={[
                    {
                      min: 10,
                      message: "Vergi Numarası 10 Karakter Olmalıdır.",
                    },
                  ]}
                >
                  <Input
                    onChange={onChangeVknValue}
                    type="number"
                    onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                    maxLength="10"
                    onInput={maxLengthCheck}
                  />
                </Form.Item>
                <Form.Item
                  label="T.C. Kimlik Numarası "
                  name="TcNo"
                  rules={[
                    {
                      min: 11,
                      message: "TC Kimlik Numarası 11 Karakter Olmalıdır.",
                    },
                  ]}
                >
                  <Input
                    onChange={onChangeTcNoValue}
                    type="number"
                    onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                    maxLength="11"
                    onInput={maxLengthCheck}
                  />
                </Form.Item>
                <Form.Item label="Telefon Numarası" name="Phone">
                  <PhoneInput
                    onChange={onChangePhoneValue}
                    inputStyle={{ width: "100%" }}
                    country="tr"
                    masks={{ tr: "(...) ...-..-.." }}
                    rules={[
                      {
                        min: 12,
                        message: "Telefon numarasını eksiksiz giriniz.",
                      },
                    ]}
                  />
                </Form.Item>
                <Form.Item
                  label="Cep Numarası"
                  name="MobilePhone"
                  rules={[
                    {
                      min: 12,
                      message: "Telefon numarasını eksiksiz giriniz.",
                    },
                  ]}
                >
                  <PhoneInput
                    onChange={onChangeMobilePhoneValue}
                    inputStyle={{ width: "100%" }}
                    country="tr"
                    masks={{ tr: "(...) ...-..-.." }}
                  />
                </Form.Item>
                <Form.Item label="Fax Numarası" name="Fax">
                  <Input onChange={onChangeFaxValue} />
                </Form.Item>
                <Form.Item label="Adres" name="Address">
                  <TextArea onChange={onChangeAddressValue} rows={4} />
                </Form.Item>
                <Form.Item label="Cari Tipi" name="FirmTypeValue">
                  <Select
                    placeholder="Seçiniz"
                    optionFilterProp="children"
                    onChange={onChangeFirmType}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    {firmTypeDropdown.map((item) => (
                      <Option key={item.key}>{item.value}</Option>
                    ))}
                  </Select>
                </Form.Item>
               <Form.Item
                    label={`${ScreenNameWithActiveTab()} Kodu`}
                  name="FirmBranchNumber"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Cari Kodu alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input disabled={IsHasSendFirmToLogo} onChange={onChangeFirmBranchNumberValue} />
                </Form.Item>
                <Form.Item
                  label="Erp Kodu"
                  name="ErpCode"
                  rules={[
                    {
                      max: 100,
                      message:
                        "Erp Kodu alanı maksimum 100 karakter olmalıdır.",
                    },
                  ]}
                >
                  <Input onChange={onChangeErpCodeValue} />
                </Form.Item>
                <Form.Item label="İl" name="City">
                  <Input onChange={onChangeCity} />
                  </Form.Item>
                  <Form.Item label="İlçe" name="Town">
                  <Input onChange={onChangeTown} />
                  </Form.Item>
                  <Form.Item label="Özel Kod" name="SpecialCode">
                  <Input onChange={onChangeSpecialCode} />
                  </Form.Item>
                  <Form.Item label="Yetki Kodu" name="AuthorizationCode">
                  <Input onChange={onChangeAuthorizationCode} />
                  </Form.Item>
                  <Form.Item label="Hesap Kodu" name="AccountCode">
                  <Input onChange={onChangeAccountCode} />
                  </Form.Item>
                <Form.Item label="Satıcı Kodu" name="ErpSalesCode">
                  <Input onChange={onChangeErpSalesCode} />
                </Form.Item>
                <Form.Item label="Cari Sınıfı" name="FirmClassId">
                  <Select
                    showSearch
                    placeholder="Seçiniz"
                    onChange={onChangeFirmClassValue}
                    onClick={onClickFirmClassValue}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    {firmClassDropdown.map((item) => (
                      <Option key={item.id}>{item.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item label="Grup Kodu" name="GroupCode">
                  <Input onChange={onChangeFirmGroupCode} />
                </Form.Item>
                <Form.Item label="Muhasebe Kodu" name="AccountingCode">
                    <Input onChange={onChangeAccountingCode} />
                  </Form.Item>
                <Form.Item label="Kelimeler" name="words">
                  {wordList.map((x, i) => {
                    return (
                      <Row>
                        <Col span={20} style={{ marginLeft: "-6%" }}>
                          <Input
                            name="word"
                            placeholder="Kelime Girin"
                            value={x.word}
                            onChange={(e) => handleInputChange(e, i)}
                          />
                        </Col>
                        <Col span={2}>
                          {wordList.length !== 1 && (
                            <Button
                              className="mr10"
                              onClick={() => handleRemoveClick(i)}
                            >
                              <MinusOutlined />
                            </Button>
                          )}
                          {wordList.length - 1 === i && (
                            <Button onClick={handleAddClick}>
                              <PlusOutlined />
                            </Button>
                          )}
                        </Col>
                      </Row>
                    );
                  })}
                </Form.Item>
              </Col>
              <Col span={6}></Col>
              <Col span={6}></Col>
              <Col span={6}></Col>
              <Col span={3}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => setLoading(true)}
                    loading={loading}
                  >
                    Güncelle
                  </Button>
                </Form.Item>
              </Col>
              <Col span={3}></Col>
            </>
          )}
          {isTabletOrMobileDevice && (
            <>
              <Col span={24}>
                <Form.Item
                  label="Cari Adı/Ünvanı"
                  name="Name"
                  style={{ marginTop: "4%" }}
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Cari Adı/Ünvanı alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input onChange={onChangeNameValue} />
                </Form.Item>
                <Form.Item label="Talimat Ünvanı" name="DirectiveName">
                  <Input onChange={onChangeDirectiveNameValue} />
                </Form.Item>
                <Form.Item label="E-Posta Adresi" name="Email">
                  <Input onChange={onChangeEmailValue} />
                </Form.Item>
                <Form.Item label="Vergi Dairesi" name="TaxOffice">
                  <Input onChange={onChangeTaxValue} />
                </Form.Item>
                <Form.Item
                  label="Vergi Numarası"
                  name="Vkn"
                  rules={[
                    {
                      min: 10,
                      message: "Vergi Numarası 10 Karakter Olmalıdır.",
                    },
                  ]}
                >
                  <Input
                    onChange={onChangeVknValue}
                    type="number"
                    onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                    maxLength="10"
                    onInput={maxLengthCheck}
                  />
                </Form.Item>
                <Form.Item
                  label="T.C. Kimlik Numarası "
                  name="TcNo"
                  rules={[
                    {
                      min: 11,
                      message: "TC Kimlik Numarası 11 Karakter Olmalıdır.",
                    },
                  ]}
                >
                  <Input
                    onChange={onChangeTcNoValue}
                    type="number"
                    onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
                    maxLength="11"
                    onInput={maxLengthCheck}
                  />
                </Form.Item>

                <Form.Item label="Telefon Numarası" name="Phone">
                  <PhoneInput
                    onChange={onChangePhoneValue}
                    inputStyle={{ width: "100%" }}
                    country="tr"
                    masks={{ tr: "(...) ...-..-.." }}
                    rules={[
                      {
                        min: 12,
                        message: "Telefon numarasını eksiksiz giriniz.",
                      },
                    ]}
                  />
                </Form.Item>
                <Form.Item
                  label="Cep Numarası"
                  name="MobilePhone"
                  rules={[
                    {
                      min: 12,
                      message: "Telefon numarasını eksiksiz giriniz.",
                    },
                  ]}
                >
                  <PhoneInput
                    onChange={onChangeMobilePhoneValue}
                    inputStyle={{ width: "100%" }}
                    country="tr"
                    masks={{ tr: "(...) ...-..-.." }}
                  />
                </Form.Item>
                <Form.Item label="Fax Numarası" name="Fax">
                  <Input onChange={onChangeFaxValue} />
                </Form.Item>
                <Form.Item label="Adres" name="Address">
                  <TextArea onChange={onChangeAddressValue} rows={4} />
                </Form.Item>
                <Form.Item label="Cari Tipi" name="FirmTypeValue">
                  <Select
                    placeholder="Seçiniz"
                    optionFilterProp="children"
                    onChange={onChangeFirmType}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    {firmTypeDropdown.map((item) => (
                      <Option key={item.key}>{item.value}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Cari Kodu"
                  name="FirmBranchNumber"
                  rules={[
                    {
                      required: true,
                      message: "Lütfen Cari Kodu alanını boş bırakmayın.",
                    },
                  ]}
                >
                  <Input onChange={onChangeFirmBranchNumberValue} />
                </Form.Item>
                <Form.Item
                  label="Erp Kodu"
                  name="ErpCode"
                  rules={[
                    {
                      max: 100,
                      message:
                        "Erp Kodu alanı maksimum 100 karakter olmalıdır.",
                    },
                  ]}
                >
                  <Input onChange={onChangeErpCodeValue} />
                </Form.Item>
                <Form.Item label="İl" name="City">
                  <Input onChange={onChangeCity} />
                  </Form.Item>
                  <Form.Item label="İlçe" name="Town">
                  <Input onChange={onChangeTown} />
                  </Form.Item>
                  <Form.Item label="Özel Kod" name="SpecialCode">
                  <Input onChange={onChangeSpecialCode} />
                  </Form.Item>
                  <Form.Item label="Yetki Kodu" name="AuthorizationCode">
                  <Input onChange={onChangeAuthorizationCode} />
                  </Form.Item>
                  <Form.Item label="Hesap Kodu" name="AccountCode">
                  <Input onChange={onChangeAccountCode} />
                  </Form.Item>
                <Form.Item label="Satıcı Kodu" name="ErpSalesCode">
                  <Input onChange={onChangeErpSalesCode} />
                </Form.Item>
                <Form.Item label="Cari Sınıfı" name="FirmClassId">
                  <Select
                    showSearch
                    placeholder="Seçiniz"
                    onChange={onChangeFirmClassValue}
                    onClick={onClickFirmClassValue}
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option.props.children
                        .toLocaleLowerCase("tr-TR")
                        .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                    }
                  >
                    {firmClassDropdown.map((item) => (
                      <Option key={item.id}>{item.name}</Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item label="Grup Kodu" name="GroupCode">
                  <Input onChange={onChangeFirmGroupCode} />
                </Form.Item>
                <Form.Item label="Kelimeler" name="words">
                  {wordList.map((x, i) => {
                    return (
                      <Row>
                        <Col span={20} style={{ marginLeft: "-6%" }}>
                          <Input
                            name="word"
                            placeholder="Kelime Girin"
                            value={x.word}
                            onChange={(e) => handleInputChange(e, i)}
                          />
                        </Col>
                        <Col span={2}>
                          {wordList.length !== 1 && (
                            <Button
                              className="mr10"
                              onClick={() => handleRemoveClick(i)}
                            >
                              <MinusOutlined />
                            </Button>
                          )}
                          {wordList.length - 1 === i && (
                            <Button onClick={handleAddClick}>
                              <PlusOutlined />
                            </Button>
                          )}
                        </Col>
                      </Row>
                    );
                  })}
                </Form.Item>
              </Col>
              <Col span={10}></Col>
              <Col span={8}>
                <Form.Item {...tailLayout}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    htmlType="submit"
                    onClick={() => setLoading(true)}
                    loading={loading}
                  >
                    Güncelle
                  </Button>
                </Form.Item>
              </Col>
              <Col span={6}></Col>
            </>
          )}
        </Row>
      </Form>
    </div>
  );
};
export default FirmUpdate;
